import React from 'react';
import { INSERT_BLOCK_SECTION, LINKING_SECTION, OVERFLOW_GROUP, OVERFLOW_GROUP_RANK, OVERFLOW_MENU, OVERFLOW_SECTION, OVERFLOW_SECTION_RANK, PIN_SECTION, TEXT_SECTION, TOOLBAR_RANK, TOOLBARS } from '@atlaskit/editor-common/toolbar';
import { PrimaryToolbar, Toolbar } from '@atlaskit/editor-toolbar';
import { SELECTION_TOOLBAR_LABEL } from './consts';
import { OverflowMenu } from './OverflowMenu';
import { Section } from './Section';
export var getToolbarComponents = function getToolbarComponents(api, disableSelectionToolbar) {
  return [{
    type: 'toolbar',
    key: TOOLBARS.INLINE_TEXT_TOOLBAR,
    component: function component(_ref) {
      var children = _ref.children;
      return /*#__PURE__*/React.createElement(Toolbar, {
        label: SELECTION_TOOLBAR_LABEL
      }, children);
    }
  }, {
    type: 'toolbar',
    key: TOOLBARS.PRIMARY_TOOLBAR,
    component: function component(_ref2) {
      var children = _ref2.children;
      return /*#__PURE__*/React.createElement(PrimaryToolbar, {
        label: 'Primary Toolbar'
      }, children);
    }
  }, {
    type: TEXT_SECTION.type,
    key: TEXT_SECTION.key,
    parents: [{
      type: 'toolbar',
      key: TOOLBARS.INLINE_TEXT_TOOLBAR,
      rank: TOOLBAR_RANK[TEXT_SECTION.key]
    }, {
      type: 'toolbar',
      key: TOOLBARS.PRIMARY_TOOLBAR,
      rank: TOOLBAR_RANK[TEXT_SECTION.key]
    }],
    component: function component(_ref3) {
      var children = _ref3.children,
        parents = _ref3.parents;
      return /*#__PURE__*/React.createElement(Section, {
        parents: parents,
        api: api,
        disableSelectionToolbar: disableSelectionToolbar,
        testId: "text-section"
      }, children);
    }
  }, {
    type: INSERT_BLOCK_SECTION.type,
    key: INSERT_BLOCK_SECTION.key,
    parents: [{
      type: 'toolbar',
      key: TOOLBARS.PRIMARY_TOOLBAR,
      rank: TOOLBAR_RANK[INSERT_BLOCK_SECTION.key]
    }],
    component: function component(_ref4) {
      var children = _ref4.children,
        parents = _ref4.parents;
      return /*#__PURE__*/React.createElement(Section, {
        testId: "insert-block-section",
        parents: parents,
        api: api,
        showSeparatorInFullPagePrimaryToolbar: true,
        isSharedSection: false
      }, children);
    }
  }, {
    type: LINKING_SECTION.type,
    key: LINKING_SECTION.key,
    parents: [{
      type: 'toolbar',
      key: TOOLBARS.INLINE_TEXT_TOOLBAR,
      rank: TOOLBAR_RANK[LINKING_SECTION.key]
    }, {
      type: 'toolbar',
      key: TOOLBARS.PRIMARY_TOOLBAR,
      rank: TOOLBAR_RANK[LINKING_SECTION.key]
    }],
    component: function component(_ref5) {
      var children = _ref5.children,
        parents = _ref5.parents;
      return /*#__PURE__*/React.createElement(Section, {
        testId: "link-section",
        parents: parents,
        api: api,
        showSeparatorInFullPagePrimaryToolbar: true
      }, children);
    }
  }, {
    type: OVERFLOW_SECTION.type,
    key: OVERFLOW_SECTION.key,
    parents: [{
      type: 'toolbar',
      key: TOOLBARS.INLINE_TEXT_TOOLBAR,
      rank: TOOLBAR_RANK[OVERFLOW_SECTION.key]
    }]
  }, {
    type: OVERFLOW_GROUP.type,
    key: OVERFLOW_GROUP.key,
    parents: [{
      type: OVERFLOW_SECTION.type,
      key: OVERFLOW_SECTION.key,
      rank: OVERFLOW_SECTION_RANK[OVERFLOW_GROUP.key]
    }]
  }, {
    type: OVERFLOW_MENU.type,
    key: OVERFLOW_MENU.key,
    parents: [{
      type: OVERFLOW_GROUP.type,
      key: OVERFLOW_GROUP.key,
      rank: OVERFLOW_GROUP_RANK[OVERFLOW_MENU.key]
    }],
    component: function component(_ref6) {
      var children = _ref6.children;
      return /*#__PURE__*/React.createElement(OverflowMenu, null, children);
    }
  }, {
    type: PIN_SECTION.type,
    key: PIN_SECTION.key,
    parents: [{
      type: 'toolbar',
      key: TOOLBARS.PRIMARY_TOOLBAR,
      rank: TOOLBAR_RANK[PIN_SECTION.key]
    }]
  }];
};